import React, { useState, useEffect } from "react";
import classnames from "classnames";
import Icon from "~/Common-Objects/UI/Icon";
import UilibDialog from "~/Common-Objects/UI/Dialog";
import Button from "../button";
import * as styles from "./index.module.scss";

export default function Dialog({
  open = false,
  title,
  description,
  submitting = false,
  fullScreen,
  size,
  container,
  onOpenChange,
  className,
  children,
  ...rest
}) {
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  useEffect(() => {
    if (onOpenChange) onOpenChange(isOpen);
  }, [isOpen]);

  // This function is called whenever the "Cancel" button is clicked or the escape key is pressed.
  function handleOpenChange(e) {
    if (submitting === false) {
      setIsOpen(e);
    }
  }

  return (
    <UilibDialog.Root open={isOpen} onOpenChange={handleOpenChange} {...rest}>
      <UilibDialog.Portal container={container}>
        <UilibDialog.Overlay />
        <UilibDialog.Content fullScreen={fullScreen} size={size}>
          <div
            className={classnames(styles.contentInner, {
              [styles.contentInnerFullScreen]: fullScreen,
            })}
          >
            {(title || description) && (
              <div className={styles.header}>
                <UilibDialog.Title className="h2">{title}</UilibDialog.Title>

                {description && (
                  <UilibDialog.Description
                    className="text-grey mar-b0"
                    dangerouslySetInnerHTML={{ __html: description }}
                  />
                )}
              </div>
            )}

            {children}
          </div>

          {fullScreen && (
            <UilibDialog.Close className={styles.closeButton} asChild>
              <Button
                variant="secondary"
                size="s"
                disabled={submitting}
                iconLeft={<Icon name="cross-large" />}
              >
                Cancel
              </Button>
            </UilibDialog.Close>
          )}
        </UilibDialog.Content>
      </UilibDialog.Portal>
    </UilibDialog.Root>
  );
}
